import { Component } from '@theme/component';

/**
 * Wraps a sortable list. Expects a child with ref="grid" whose children
 * carry `data-published-at` (Unix seconds). A child select with
 * `on:change="/handleSort"` reorders the grid client-side.
 *
 * @typedef {Object} NcnSortableGridRefs
 * @property {HTMLElement} grid - Container of sortable items
 *
 * @extends {Component<NcnSortableGridRefs>}
 */
class NcnSortableGrid extends Component {
  /**
   * @param {Event} event
   */
  handleSort(event) {
    const select = /** @type {HTMLSelectElement} */ (event.target);
    const order = select.value === 'oldest' ? 'oldest' : 'latest';
    this.applySort(order);
  }

  /**
   * @param {'latest' | 'oldest'} order
   */
  applySort(order) {
    const grid = this.refs.grid;
    if (!grid) return;
    const items = Array.from(grid.children);
    items.sort((a, b) => {
      const aTime = Number(/** @type {HTMLElement} */ (a).dataset.publishedAt) || 0;
      const bTime = Number(/** @type {HTMLElement} */ (b).dataset.publishedAt) || 0;
      return order === 'oldest' ? aTime - bTime : bTime - aTime;
    });
    for (const item of items) grid.appendChild(item);
  }
}

if (!customElements.get('ncn-sortable-grid')) {
  customElements.define('ncn-sortable-grid', NcnSortableGrid);
}
